export default "__VITE_ASSET__jqNrSSKsx5Sw$RlpqDztsQ__"